exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "md-dialog:has(> .confirmationCodeForm) {\n  max-width: 400px;\n}", ""]);

// exports
